export class EncryptionService {
    private secretKey: string | null = null;
    isAdmin: boolean;
    permitted_tabs: any = [];

    constructor() {
        this.secretKey = "Skillflo An AI based Elearning web application";
    }


    encrypt(text: string, secretKey: string = this.secretKey): string {
        if (!secretKey) throw new Error("Secret key is required for encryption");
        const textChars = text.split("");
        const keyChars = secretKey.split("");
        const result = textChars.map((char, index) => {
            return char.charCodeAt(0) ^ keyChars[index % keyChars.length].charCodeAt(0);
        });
        let encryptedtext = result.join(",");
        return this.convertToHex(encryptedtext)
    }

    convertToHex(result) {
        const hexString = result
            .split(",")
            .map((num) => parseInt(num, 10).toString(16).padStart(2, "0"))
            .join("");
        return hexString;
    }

    convertHexToEncryptedText(hexString) {
        const encryptedArray = [];
        for (let i = 0; i < hexString.length; i += 2) {
            const hexPair = hexString.substr(i, 2);
            encryptedArray.push(parseInt(hexPair, 16));
        }

        return encryptedArray.join(",");
    }

    decrypt(encryptedText: string, secretKey: string = this.secretKey): string {
        if (!secretKey) throw new Error("Secret key is required for decryption");
        let hextoString = this.convertHexToEncryptedText(encryptedText)
        const encryptedArray = hextoString.split(",").map(Number);
        const keyChars = secretKey.split("");
        const result = encryptedArray.map((num, index) => {
            return String.fromCharCode(
                num ^ keyChars[index % keyChars.length].charCodeAt(0)
            );
        });
        return result.join("");
    }

    async allowedPermissions() {
        const acl = localStorage.getItem('acl');
        const decryptedData = this.decrypt(acl);
        console.log('Decrypted:', decryptedData);

        const parsedData = JSON.parse(decryptedData);
        parsedData.role.forEach(element => {
            this.permitted_tabs.push(element.id);
        });

        console.log(this.permitted_tabs, "----------ALL IDS");
        return this.permitted_tabs


    }
}
